import { ReactNode, ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';

import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

type HeaderContentProps = Readonly<{
  children: ReactNode;
}>;

export const HeaderContent = ({ children }: HeaderContentProps): ReactElement => {
  return <Box sx={containerStyle}>{children}</Box>;
};

const containerStyle: SxProps<Theme> = {
  backgroundColor: appColors.neutral.white,
  padding: '10px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  maxWidth: '100%',
  minWidth: '30%',
  borderBottom: `2px solid ${appColors.color.blue1}`,
};
